import { z } from "zod";
import { UrlSchema, ChapterIndexSchema, AdapterIdSchema } from "./primitives.js";

export const NovelStatusSchema = z.enum(["ongoing", "completed", "hiatus", "unknown"]);

export const NovelMetadataSchema = z
  .object({
    sourceUrl: UrlSchema,
    sourceSite: AdapterIdSchema,
    title: z.string().min(1),
    author: z.string(),
    description: z.string(),
    coverUrl: UrlSchema.optional(),
    genres: z.array(z.string()).readonly(),
    status: NovelStatusSchema,
    totalChapters: z.number().int().nonnegative().optional(),
    fetchedAt: z.coerce.date(),
  })
  .readonly();

export const ChapterRefSchema = z
  .object({
    index: ChapterIndexSchema,
    title: z.string(),
    url: UrlSchema,
    volume: z.string().optional(),
  })
  .readonly();

export const ChapterSchema = z
  .object({
    index: ChapterIndexSchema,
    title: z.string(),
    url: UrlSchema,
    volume: z.string().optional(),
    content: z.string(),
    fetchedAt: z.coerce.date(),
    wordCount: z.number().int().nonnegative(),
  })
  .readonly();

export const NovelDataSchema = z
  .object({
    metadata: NovelMetadataSchema,
    chapters: z.array(ChapterSchema).readonly(),
  })
  .readonly();
